<script>
	import { onMount, onDestroy } from "svelte";
	import { navigate } from "svelte-routing";
	import { Button, Col, Row } from "@sveltestrap/sveltestrap";
	import client from "../../../services/client";
	import {
		errorMessage,
		sizeSelect,
		totalPages,
		loading,
		initPage,
	} from "../../../store/store";
	import ErrorMessageHandler from "../../../components/ErrorMessageHandler/ErrorMessageHandler.svelte";
	import PageHeader from "../../../components/PageHeader/PageHeader.svelte";
	import FilterForm from "../../../components/FilterForm/FilterForm.svelte";
	import SizeSelect from "../../../components/SizeSelect/SizeSelect.svelte";
	import ManageTable from "./ManageTable.svelte";
	import { extractErrorMessage } from "src/utils/misc";

	let data = [];
	const params = new Proxy(new URLSearchParams(window.location.search), {
		get: (searchParams, prop) => searchParams.get(prop),
	});
	$: queryParams = `?page=1&size=${$sizeSelect}`;
	let searchParams = window.location.search.toString();
	let queryStatus = searchParams.includes("status");
	let querySearch = searchParams.includes("search");
	let queryPage = searchParams.includes("page");
	$: if (queryPage) {
		queryParams = `?page=${params.page}&size=${$sizeSelect}`;
		initPage.set(+params.page);
	}
	$: if (queryStatus) {
		queryParams = queryParams.concat(`&isEnabled=${params.status}`);
	}
	$: if (querySearch) {
		queryParams = queryParams.concat(`&keyword=${params.search}`);
	}

	async function fetchUsers() {
		try {
			loading.set(true);
			const res = await client(`/v1/users${queryParams}`, {
				method: "GET",
				version: "User",
			});
			data = res.data.data;
			totalPages.set(res.data.totalPage);
			loading.set(false);
		} catch (err) {
			loading.set(false);
			extractErrorMessage(err);
			console.log(err);
		}
	}

	async function handleUserStatus(id, status) {
		try {
			loading.set(true);
			const res = await client("/v1/users", {
				method: "PUT",
				version: "User",
				data: {
					id,
					isEnabled: status,
				},
			});
			if (res.status === 200) {
				fetchUsers();
				loading.set(false);
			}
		} catch (err) {
			loading.set(false);
			console.log(err.response);
		}
	}

	onMount(async () => {
		fetchUsers();
	});
	let err;
	errorMessage.subscribe((value) => {
		err = value;
	});

	onDestroy(() => {
		initPage.set(1);
		sizeSelect.set("20");
		totalPages.set(1);
	});
</script>

<Row>
	<Col xs={12}>
		<div>
			<ErrorMessageHandler message={err} />
			<Col className="row d-flex align-items-start mx-0">
				<PageHeader title="FMS Account Management" />
			</Col>
			<div class="d-flex flex-row">
				<Col xs={6}>
					<FilterForm searchParameter status fmsUserStatus />
				</Col>
				<Col class="d-flex justify-content-end" xs={6}>
					<div class="mx-2">
						<Button
							class="themeButton primary px-4"
							on:click={() =>
								navigate(
									"/account/fms-account-management/create"
								)}>CREATE USER</Button
						>
						<div class="my-2">
							<SizeSelect trigerSelect={fetchUsers} />
						</div>
					</div>
				</Col>
			</div>
			<div />
		</div>
	</Col>
	<Col class="my-2">
		<ManageTable {data} {handleUserStatus} />
	</Col>
</Row>
